import { render, staticRenderFns } from "./ApproveDigitalLeadOrders.vue?vue&type=template&id=5384d402&"
import script from "./ApproveDigitalLeadOrders.vue?vue&type=script&lang=js&"
export * from "./ApproveDigitalLeadOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports